export const isSuperUser = (email) => {
  return [
    "kurt.gutteridge@nas.com.mt",
    "tonysammut@gmail.com",
    "zsigovof@gmail.com",
    "istvan-zsigovics@incredible-web.com",
  ].includes(email);
};
